<template>
  <div class="extraction-template-draft-status">
    <v-chip v-if="isDraft" class="font-weight-bold" color="primary">
      <div class="mx-2">
        <v-icon left small>edit</v-icon>
        Draft
      </div>
    </v-chip>
    <v-chip v-else class="font-weight-bold" color="success">
      <div class="mx-2">
        <v-icon left small>check</v-icon>
        Published
      </div>
    </v-chip>
    {{ statusText }}
  </div>
</template>

<script>
import { Review } from '@/models';
import { formatDistance } from 'date-fns';

export default {
  name: 'ExtractionTemplateDraftStatus',
  props: {
    review: {
      type: Review,
      required: true,
    },
  },
  computed: {
    isDraft() {
      return this.review.extractionTemplateIsDraft();
    },
    statusText() {
      const publishedDate = this.review.dataExtractionTemplatePublishedAt.toDate();
      const timeAgo = publishedDate
        ? formatDistance(publishedDate, Date.now(), {
            addSuffix: true,
          })
        : 'never';
      if (this.isDraft) {
        return `Last published ${timeAgo}`;
      } else {
        return timeAgo;
      }
    },
  },
};
</script>

<style scoped>
.extraction-template-draft-status {
  display: grid;
  grid: 'chip text' / auto 1fr;
  grid-gap: 1rem;
  align-items: center;
}
</style>
